import { render, staticRenderFns } from "./DeleteVertexSoft.vue?vue&type=template&id=19044a4a&"
import script from "./DeleteVertexSoft.vue?vue&type=script&lang=js&"
export * from "./DeleteVertexSoft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports